import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { LessorStakeholderDto, LessorInfoDto, LessorRepTypeDto, AddressBookDto, BankDto, LandTitleDto } from '@cradua/data';
import { SearchModalComponent } from 'libs/acquisition/src/lib/components/search-modal/search-modal.component';
import Swal from 'sweetalert2';
import { StakeholderTableComponent } from './stakeholder-table/stakeholder-table.component';

@Component({
  selector: 'cradua-stakeholder',
  templateUrl: './stakeholder.component.html',
  styleUrls: ['./stakeholder.component.scss']
})
export class StakeholderComponent implements OnInit {

  @Input() selectedLessorInfo: LessorInfoDto;
  @Input() banks: BankDto[];
  @Input() addressBook: AddressBookDto[];
  @Input() isLoadingLessorStakeholder: boolean;
  @Input() lessorStakeholders: LessorStakeholderDto[];
  @Output() emitLessorStakeholder = new EventEmitter<any>();
  @Output() emitLessorStakeholderDelete = new EventEmitter<any>();
  @Output() emitTask = new EventEmitter<any>();
  @ViewChild(StakeholderTableComponent) child: StakeholderTableComponent;
  lessorStakeholderForm: FormGroup;
  selectedIndex = null;
  selectedAddressBook: AddressBookDto;

  constructor(
    private fb: FormBuilder,
    public dialog: MatDialog,
    ) { }

  ngOnInit(): void {
    this.createStakeholderForm();
  }

  createStakeholderForm() {
    this.lessorStakeholderForm = this.fb.group({
      PhoneNo: [{value: null, disabled: true}],
      Name: [{value: null, disabled: false}],
      Address: [{value: null, disabled: true}],
      AccountNo: [{value: null, disabled: true}],
      BankId: [{value: null, disabled: true}],
      AddressBookId: null,
      LandTitleId: null,
    });
  }

  onEdit(value: any) {
    this.selectedIndex = value['index'];
    this.lessorStakeholderForm.patchValue({
      PhoneNo: value.PhoneNo,
      Name: value.Name,
      Address: value.Address,
      AccountNo: value.AccountNo,
      BankId: value.BankId,
      AddressBookId: value.AddressBookId,
      LandTitleId: value.LandTitleId,
      LessorsId: this.selectedLessorInfo.id,
    });
  }

  addNew(formValue: any) {
    if(this.lessorStakeholderForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.child.lessorStakeholderFormArray['controls'][this.selectedIndex].patchValue(formValue);
    } else {
      this.child.addLessorStakeholder({
        PhoneNo: formValue.PhoneNo,
        Name: formValue.Name,
        Address: formValue.Address,
        AccountNo: formValue.AccountNo,
        BankId: formValue.BankId,
        AddressBookId: formValue.AddressBookId,
        LandTitleId: formValue.LandTitleId,
        LessorsId: this.selectedLessorInfo.id,
      });
    }
    this.selectedIndex = null;
    this.lessorStakeholderForm.reset()
  }

  onSubmit(){

    this.emitLessorStakeholder.emit(this.child.lessorStakeholderArrayForm.value['LessorStakeholder']);
    if(this.child.filteredDelete.length > 0) {

      this.emitLessorStakeholderDelete.emit(this.child.filteredDelete);
    }

  }

  onReset() {
    this.lessorStakeholderForm.reset();
    this.selectedIndex = null;
  }

  onBack() {
    this.emitTask.emit('list');
  }


  onSearchDialog() {

    const dialogConfig = new MatDialogConfig();

    // dialogConfig.disableClose = false;
    dialogConfig.id = "modal-component";
    dialogConfig.height = "90%";
    dialogConfig.width = "100%";
    // dialogConfig.minHeight = '100vh';
    // dialogConfig.minWidth = '100%'
    // dialogConfig.panelClass = "custom-dialog-container";
    // dialogConfig.backdropClass = "backdropBackground";


    const dialogRef = this.dialog.open(
      SearchModalComponent,
      dialogConfig,
    );

    dialogRef.afterClosed().subscribe((result: AddressBookDto) => {
      this.selectedAddressBook = result;
      if(result !== undefined) {
        this.lessorStakeholderForm.patchValue({
          PhoneNo:  result.PhoneNo,
          Name:  result.Name,
          Address: result.Address,
          AccountNo: result.AccountNo,
          BankId: result.BankId,
          AddressBookId: result.id,
        });
      }

    });
  }

}


